import {Observable, Subscription} from 'rxjs';

import LocalStorage from '../../LocalStorage/LocalStorage';
import IVolumeStore from '../Interfaces/IVolumeStore';

const subscribeToLocalStorageVolume = (
    localStorageVolume$: Observable<LocalStorage>,
    volumeStore: IVolumeStore
): Subscription =>
    localStorageVolume$
        .subscribe(({volumeLevel, volumeMuted}) => {
            if (volumeMuted) {
                volumeStore.actions.mute();
            } else {
                volumeStore.actions.setLevel(volumeLevel);
            }

            volumeStore.actions.setPreMuteLevel(volumeLevel);
        });

export default subscribeToLocalStorageVolume;